/**
 * by https://medium.com/@mariusc23/hide-header-on-scroll-down-show-on-scroll-up-67bbaae9a78c
 * автоскрытие макета, при скролле вниз, и раскрытие, при скролле вверх
 */
import {Widget} from "base/assets/js/widget/Widget.js";

export class LayoutScroll extends Widget {

	_bFixed;
	_iPrevScroll;
	_iDelta = 20;
	_iHeaderHeight;
	_bDisabled = false;

	run() {
		this._iHeaderHeight = this._el( 'Header' ).clientHeight;
		this._fnExec = ::this.exec;

		this._on( window, 'scroll', this._fnExec )
	}

	destructor() {
		this._off( window, 'scroll', this._fnExec )
	}

	disable( bVal ) {
		this._bDisabled = bVal;
	}

	exec() {

		if( this._bDisabled ) {
			return;
		}

		const iCurScroll = this._getCurScroll();

		// самый первый заход может быть на #, и не надо сразу показывать layout
		if( typeof this._iPrevScroll === "undefined" ) {
			this._iPrevScroll = iCurScroll;
			return;
		}

		if(Math.abs(this._iPrevScroll - iCurScroll) <= this._iDelta ) {
			return;
		}

		const bPrevValue = this._bFixed;
		let bNewValue = bPrevValue;
		if (iCurScroll > this._iPrevScroll ) {
			bNewValue = false;
		} else {
		 	if( iCurScroll + window.innerHeight < document.documentElement.scrollHeight && iCurScroll > this._iHeaderHeight ) {
				bNewValue = true;
		 	}
		}
		if( bPrevValue !== bNewValue ) {
			this.state( bNewValue, true,false );
		}
		this._iPrevScroll = iCurScroll;
	}

	state( bFixed, bAnimate = false, bSetPrevScroll = true ) {
		this._bFixed = bFixed;
		this._mod( '', 'body_layout-fixed', this._bFixed );
		this._mod( '', 'body_layout-fixed-an', bAnimate && this._bFixed );
		if( bSetPrevScroll ) {
			this._iPrevScroll = this._getCurScroll();
		}
	}

	_getCurScroll() {
		return window.scrollY || document.scrollTop
	}
}